import * as React from 'react';
import {FunctionComponent, useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {Button} from '../../components/Button';
import {FormInput} from '../../components/form/FormInput';
import Toastify from 'toastify-js';
import {api} from '../../ApiFacade';
import {UserStatsResponse} from '../../swagger';
import {showCommunicationError} from '../../helpers/alerts';
import {formatDateTime} from '../../helpers/helpers';
import MusculaLog from '@muscula.com/muscula-webapp-js-logger';

export interface DevPanelProps {

}

export const DevPanel: FunctionComponent<DevPanelProps> = observer(() => {
    const [message, setMessage] = useState('Test Error from DevPanel');

    const [list, setList] = useState<UserStatsResponse[]>([]);

    // @ts-ignore
    useEffect(() => {
        let mounted = true;
        api().userAuth.userAuthStatsGet()
            .then(res => {
                if (mounted) {
                    setList(res.content ?? []);
                }
            }).catch((err: Error) => showCommunicationError(err));
        return () => mounted = false;
    }, []);

    return <div>
        <h1>DevPanel</h1><br/>
        <form onSubmit={(e) => e.preventDefault()}>
            <FormInput id={'dev message'} label={'Error message'} name={'error_message'} onChange={(v) => setMessage(v)} value={message}/>
            <Button onClick={() => {
                throw new Error(message);
            }}>Throw error</Button>
            <Button onClick={() => {
                MusculaLog.Info('Info message');
            }}>LogInfo</Button>
            <Button onClick={() => {
                try {
                    throw new Error('Test error');
                } catch (ex) {
                    MusculaLog.Error('Test exception', ex, {'value1': 'res1', 'value2' : 2});
                }
            }}>Throw and catch error</Button>
            <Button onClick={() => {
                Toastify({
                    text: 'This is a toast',
                    duration: 3000,
                    close: true,
                    gravity: 'bottom',
                    position: 'right',
                    backgroundColor: '#C31010',
                    stopOnFocus: true,
                    onClick: function() {
                    }
                }).showToast();
            }}>Show toast</Button>
        </form>
        <br/>
        <br/>
        <h3>
            User stats
        </h3>
        <table className="table-auto border-collapse border-b-1 table shadow-lg bg-gray w-full hover">
            <thead>
            <tr>
                <td>
                    User
                </td>
                <td>
                    ID
                </td>
                <td>
                    Last login
                </td>
                <td>
                    Login count
                </td>
                <td>
                    Projects count
                </td>
                <td>
                    Logs count
                </td>
            </tr>
            </thead>
            <tbody>
            {list.map(u => <tr key={'userstat' + u.userId}>
                <td>
                    {u.email}
                </td>
                <td>
                    {u.userId}
                </td>
                <td>
                    {formatDateTime(u.lastLogin)}
                </td>
                <td>
                    {u.loginCount}
                </td>
                <td>
                    {u.projectsCount}
                </td>
                <td>
                    {u.logsCount}
                </td>
            </tr>)}
            </tbody>

        </table>
    </div>;
});
